import { InjectionToken } from '@angular/core';
import { LayoutModuleConfig } from '@portal-core/layout/models/layout-module-config';

export const LayoutModuleConfigService = new InjectionToken<LayoutModuleConfig>('LayoutModuleConfig');
